
import { motion } from 'framer-motion';

export const SalesVisuals = () => {
    return (
        <div className="w-full h-full bg-white relative overflow-hidden flex flex-col items-center justify-center p-8 font-jakarta">
            <div className="relative w-full max-w-[500px]">
                {/* Proposal Cover */}
                <motion.div
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6 }}
                    className="w-full aspect-[16/9] bg-white rounded-xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.15)] border border-gray-200 relative overflow-hidden z-10 flex flex-col"
                >
                    {/* Hero Image Area */}
                    <div className="h-[55%] bg-blue-700 relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-blue-700 via-blue-600 to-indigo-600" />

                        {/* Abstract Shapes */}
                        <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl transform translate-x-1/2 -translate-y-1/2" />
                        <div className="absolute bottom-0 left-0 w-32 h-32 bg-black/10 rounded-full blur-2xl transform -translate-x-1/2 translate-y-1/2" />

                        <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                            <div className="w-12 h-12 bg-white/20 rounded-xl backdrop-blur-md border border-white/30 flex items-center justify-center mb-3">
                                <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>
                            </div>
                            <h3 className="font-bold text-lg tracking-wide">Enterprise Solution</h3>
                            <p className="text-blue-100 text-xs mt-1">Prepared for Acme Corp</p>
                        </div>
                    </div>

                    {/* Proposal Details */}
                    <div className="flex-1 p-6 flex justify-between items-end bg-white">
                        <div className="space-y-1">
                            <h4 className="font-bold text-gray-900 text-sm">Strategic Partnership Proposal</h4>
                            <p className="text-xs text-gray-500">Valid until: Dec 31, 2024</p>
                        </div>
                        <div className="text-right">
                            <div className="bg-blue-50 text-blue-700 px-4 py-1.5 rounded-lg text-[11px] font-bold tracking-wide border border-blue-100 uppercase">
                                Draft Mode
                            </div>
                        </div>
                    </div>
                </motion.div>

                {/* Background Sheets (Stack Effect) */}
                <motion.div initial={{ rotate: 3, opacity: 0 }} animate={{ rotate: 2, opacity: 1 }} transition={{ delay: 0.2 }} className="absolute inset-0 bg-gray-50 border border-gray-200 rounded-xl shadow-lg z-0 transform translate-x-3 translate-y-3" />
                <motion.div initial={{ rotate: 6, opacity: 0 }} animate={{ rotate: 4, opacity: 1 }} transition={{ delay: 0.3 }} className="absolute inset-0 bg-white border border-gray-100 rounded-xl shadow-md z-[-1] transform translate-x-6 translate-y-6" />

                {/* Success Indicator - CRM Update */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: 0.8 }}
                    className="absolute -bottom-10 left-8 right-8 bg-[#0f172a] text-white p-4 rounded-xl shadow-2xl z-20 flex justify-between items-center ring-1 ring-white/10"
                >
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center shadow-lg shadow-green-900/20">
                            <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" /></svg>
                        </div>
                        <div>
                            <div className="text-sm font-bold">Proposal Sent</div>
                            <div className="text-[10px] text-gray-400">HubSpot CRM Updated</div>
                        </div>
                    </div>
                    <span className="text-[10px] font-mono text-gray-500 bg-gray-800 px-2 py-1 rounded">Just now</span>
                </motion.div>

                {/* Branding Badge */}
                <motion.div
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ delay: 1 }}
                    className="absolute -top-4 -right-4 bg-white p-2.5 rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-gray-100 z-30"
                >
                    <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center border border-indigo-100">
                        <span className="font-bold text-indigo-600 text-xs">LOGO</span>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};
